'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherActivity, FeatherBarChart2, FeatherBell, FeatherBook, FeatherBuilding2, FeatherCalendar, FeatherCheckSquare, FeatherChevronsLeft, FeatherChevronsRight, FeatherClock, FeatherCopy, FeatherDollarSign, FeatherFileText, FeatherGitBranch, FeatherInbox, FeatherLogOut, FeatherMessageCircle, FeatherMessageSquare, FeatherMonitor, FeatherPackage, FeatherScale, FeatherTag, FeatherTrendingUp, FeatherUsers } from '@subframe/core';
import { IntegracaoAlertasBadge } from '../IntegracaoAlertasBadge';
import { IntegracaoStatusNavIcon } from '../IntegracaoStatusNavIcon';
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import React from 'react';
import { SidebarWithCollapsibleSections } from '@/shared/components/ui';
import { usePermissao } from '@/shared/hooks/usePermissao';
import { useAppSelector } from '@/store/hooks';
import { useNavegacaoProtegida } from '../../contexts/NavegacaoProtegidaContext';
import { painelPermissoesSecretariaHabilitado } from '../../utils/flagPainelPermissoesSecretaria';
import { AdminRoleSwitcher, type AdminRole } from './AdminRoleSwitcher';
type AdminSection = 'administrativo' | 'operacoes' | 'secretaria' | 'atendimento' | 'financeiro' | 'flows' | 'plataforma';
const ROLE_STORAGE_KEY = 'adminGeral.selectedRole';
const DEFAULT_ADMIN_ROLE: AdminRole = 'ADMIN_PLATAFORMA';
const SECTION_VISIBILITY: Record<AdminRole, ReadonlySet<AdminSection>> = {
  ADMIN_PLATAFORMA: new Set(['administrativo', 'operacoes', 'atendimento', 'financeiro', 'plataforma']),
  SECRETARIA: new Set(['secretaria', 'atendimento']),
  DESENVOLVEDOR: new Set(['operacoes', 'flows', 'plataforma'])
};
const isAdminRole = (value: string | null): value is AdminRole => value === 'ADMIN_PLATAFORMA' || value === 'SECRETARIA' || value === 'DESENVOLVEDOR';
interface AdminSidebarProps {
  isMobile?: boolean;
  onNavigate?: () => void;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  onLogout: () => void;
}
const getNavItemClassName = (isCollapsed: boolean, extraClassName: string = ''): string => {
  const base = isCollapsed ? 'w-full flex-none' : 'h-10 w-full flex-none';
  return extraClassName ? `${extraClassName} ${base}` : base;
};
const getInteractiveProps = (onActivate: () => void): Pick<React.HTMLAttributes<HTMLDivElement>, 'role' | 'tabIndex' | 'onClick' | 'onKeyDown'> => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onActivate();
    }
  };
  return {
    role: 'button',
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: handleKeyDown
  };
};
export const AdminSidebar: React.FC<AdminSidebarProps> = t0 => {
  const $ = _c(115);
  const {
    isMobile: t1,
    onNavigate,
    isCollapsed: t2,
    onToggleCollapse,
    onLogout
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const isCollapsed = t2 === undefined ? false : t2;
  const router = useRouter();
  const navegacaoProtegida = useNavegacaoProtegida();
  const pathname = usePathname();
  const tipoUsuario = useAppSelector(_temp);
  const {
    pode,
    podeNaArea
  } = usePermissao();
  const [selectedRole, setSelectedRole] = React.useState(tipoUsuario === "SECRETARIA" ? "SECRETARIA" : DEFAULT_ADMIN_ROLE);
  let t3;
  let t4;
  if ($[0] !== tipoUsuario) {
    t3 = () => {
      if (tipoUsuario === "SECRETARIA") {
        setSelectedRole("SECRETARIA");
        return;
      }
      const stored = window.localStorage.getItem(ROLE_STORAGE_KEY);
      if (isAdminRole(stored)) {
        setSelectedRole(stored);
      }
    };
    t4 = [tipoUsuario];
    $[0] = tipoUsuario;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  React.useEffect(t3, t4);
  const isSecretaria = tipoUsuario === "SECRETARIA";
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = role => {
      setSelectedRole(role);
      window.localStorage.setItem(ROLE_STORAGE_KEY, role);
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleSelectRole = t5;
  let t6;
  if ($[4] !== selectedRole) {
    t6 = section => SECTION_VISIBILITY[selectedRole].has(section);
    $[4] = selectedRole;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const canSee = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = painelPermissoesSecretariaHabilitado();
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const painelPermissoesSecretaria = t7;
  let t8;
  if ($[7] !== pode) {
    t8 = pode("painel.visualizar");
    $[7] = pode;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const verPainelGeral = t8;
  let t9;
  if ($[9] !== podeNaArea) {
    t9 = podeNaArea("triagem");
    $[9] = podeNaArea;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const verTriagem = t9;
  let t10;
  if ($[11] !== podeNaArea) {
    t10 = podeNaArea("prazos");
    $[11] = podeNaArea;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const verPrazos = t10;
  let t11;
  if ($[13] !== podeNaArea) {
    t11 = podeNaArea("processos");
    $[13] = podeNaArea;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const verProcessos = t11;
  let t12;
  if ($[15] !== podeNaArea) {
    t12 = podeNaArea("ar");
    $[15] = podeNaArea;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const verAr = t12;
  const verGestaoPermissoes = tipoUsuario === "ADMIN" && painelPermissoesSecretaria;
  const secaoSecretariaTemItem = verGestaoPermissoes || verPainelGeral || verTriagem || verPrazos || verProcessos || verAr;
  const configuraCamara = tipoUsuario === "ADMIN";
  const isDesktopCollapsed = !isMobile && isCollapsed;
  let t13;
  if ($[17] !== navegacaoProtegida || $[18] !== onNavigate || $[19] !== router) {
    t13 = path => {
      const seguir = () => {
        router.push(path);
        if (onNavigate) {
          onNavigate();
        }
      };
      if (navegacaoProtegida) {
        navegacaoProtegida.navegar(seguir);
      } else {
        seguir();
      }
    };
    $[17] = navegacaoProtegida;
    $[18] = onNavigate;
    $[19] = router;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const handleNavigate = t13;
  let t14;
  if ($[21] !== navegacaoProtegida || $[22] !== onLogout) {
    t14 = () => {
      if (navegacaoProtegida) {
        navegacaoProtegida.navegar(onLogout);
      } else {
        onLogout();
      }
    };
    $[21] = navegacaoProtegida;
    $[22] = onLogout;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const handleLogout = t14;
  const t15 = isMobile ? "flex" : "hidden lg:flex";
  let t16;
  if ($[24] !== isCollapsed || $[25] !== isMobile || $[26] !== isSecretaria || $[27] !== selectedRole) {
    t16 = !isMobile ? <div className="flex w-full flex-col py-2"><div className="relative flex w-full items-center" style={{
        height: "40px"
      }}><div style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: isCollapsed ? 1 : 0,
          transform: isCollapsed ? "scale(1)" : "scale(0.7)",
          transition: "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1), transform 300ms cubic-bezier(0.4, 0, 0.2, 1)",
          pointerEvents: isCollapsed ? "auto" : "none"
        }}><Image src="/icone.svg" alt="Arbitralis" width={32} height={32} className="h-8 w-8" /></div><div style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          gap: "10px",
          opacity: isCollapsed ? 0 : 1,
          transform: isCollapsed ? "translateX(-8px)" : "translateX(0px)",
          transition: "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1), transform 350ms cubic-bezier(0.4, 0, 0.2, 1)",
          pointerEvents: isCollapsed ? "none" : "auto"
        }}><Image src="/Logo.svg" alt="Arbitralis" width={160} height={32} className="h-8 w-auto" /><span className="bg-brand-100 text-brand-700 rounded px-1.5 py-0.5 text-[10px] font-semibold tracking-wider uppercase">Admin</span></div></div>{!isSecretaria ? <div className="w-full pt-3"><AdminRoleSwitcher selected={selectedRole} onSelect={handleSelectRole} isCollapsed={isCollapsed} /></div> : null}</div> : null;
    $[24] = isCollapsed;
    $[25] = isMobile;
    $[26] = isSecretaria;
    $[27] = selectedRole;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== isCollapsed || $[30] !== isMobile || $[31] !== onToggleCollapse) {
    t17 = !isMobile && onToggleCollapse && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={isCollapsed ? <FeatherChevronsRight /> : <FeatherChevronsLeft />} isCollapsed={isCollapsed} {...getInteractiveProps(onToggleCollapse)}>{isCollapsed ? "Expandir" : "Recolher menu"}</SidebarWithCollapsibleSections.NavItem>;
    $[29] = isCollapsed;
    $[30] = isMobile;
    $[31] = onToggleCollapse;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== isCollapsed) {
    t18 = getNavItemClassName(isCollapsed, "text-error-600 hover:bg-error-50");
    $[33] = isCollapsed;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <FeatherLogOut className="text-error-600" />;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== handleLogout) {
    t20 = getInteractiveProps(handleLogout);
    $[36] = handleLogout;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== isDesktopCollapsed || $[39] !== t18 || $[40] !== t20) {
    t21 = <SidebarWithCollapsibleSections.NavItem className={t18} icon={t19} isCollapsed={isDesktopCollapsed} {...t20}>Sair</SidebarWithCollapsibleSections.NavItem>;
    $[38] = isDesktopCollapsed;
    $[39] = t18;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t17 || $[43] !== t21) {
    t22 = <>{t17}{t21}</>;
    $[42] = t17;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== canSee || $[46] !== handleNavigate || $[47] !== isCollapsed || $[48] !== isDesktopCollapsed || $[49] !== pathname) {
    t23 = canSee("administrativo") && <SidebarWithCollapsibleSections.NavSection label="Administrativo" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBuilding2 />} selected={pathname === "/admin-geral/tenants"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/tenants"))}>Escritórios</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherUsers />} selected={pathname === "/admin-geral/usuarios"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/usuarios"))}>Usuários Globais</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[45] = canSee;
    $[46] = handleNavigate;
    $[47] = isCollapsed;
    $[48] = isDesktopCollapsed;
    $[49] = pathname;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== canSee || $[52] !== handleNavigate || $[53] !== isCollapsed || $[54] !== isDesktopCollapsed || $[55] !== pathname) {
    t24 = canSee("operacoes") && <SidebarWithCollapsibleSections.NavSection label={"Opera\xE7\xF5es"} isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBell />} selected={pathname === "/admin-geral/operacoes/notificacoes"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/operacoes/notificacoes"))}>Notificações Globais</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherMessageSquare />} selected={pathname === "/admin-geral/operacoes/negociacoes"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/operacoes/negociacoes"))}>Negociações Globais</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherScale />} selected={pathname === "/admin-geral/operacoes/arbitragens"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/operacoes/arbitragens"))}>Arbitragens Globais</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[51] = canSee;
    $[52] = handleNavigate;
    $[53] = isCollapsed;
    $[54] = isDesktopCollapsed;
    $[55] = pathname;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== canSee || $[58] !== handleNavigate || $[59] !== isCollapsed || $[60] !== isDesktopCollapsed || $[61] !== pathname || $[62] !== verGestaoPermissoes) {
    t25 = verGestaoPermissoes && !canSee("secretaria") && canSee("administrativo") && <SidebarWithCollapsibleSections.NavSection label="Secretaria" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherUsers />} selected={pathname.startsWith("/admin-geral/secretaria/usuarios-permissoes")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/usuarios-permissoes"))}>Usuários e permissões</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[57] = canSee;
    $[58] = handleNavigate;
    $[59] = isCollapsed;
    $[60] = isDesktopCollapsed;
    $[61] = pathname;
    $[62] = verGestaoPermissoes;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== canSee || $[65] !== configuraCamara || $[66] !== handleNavigate || $[67] !== isCollapsed || $[68] !== isDesktopCollapsed || $[69] !== pathname || $[70] !== secaoSecretariaTemItem || $[71] !== verAr || $[72] !== verGestaoPermissoes || $[73] !== verPainelGeral || $[74] !== verPrazos || $[75] !== verProcessos || $[76] !== verTriagem) {
    t26 = canSee("secretaria") && <>{secaoSecretariaTemItem && <SidebarWithCollapsibleSections.NavSection label="Secretaria" isCollapsed={isDesktopCollapsed}>{verGestaoPermissoes && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherUsers />} selected={pathname.startsWith("/admin-geral/secretaria/usuarios-permissoes")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/usuarios-permissoes"))}>Usuários e permissões</SidebarWithCollapsibleSections.NavItem>}{verPainelGeral && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherMonitor />} selected={pathname === "/admin-geral/secretaria"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria"))}>Painel geral</SidebarWithCollapsibleSections.NavItem>}{verTriagem && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCheckSquare />} selected={pathname === "/admin-geral/secretaria/triagem"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/triagem"))}>Triagem</SidebarWithCollapsibleSections.NavItem>}{verPrazos && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCalendar />} selected={pathname === "/admin-geral/secretaria/prazos"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/prazos"))}>Prazos</SidebarWithCollapsibleSections.NavItem>}{verProcessos && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherFileText />} selected={pathname === "/admin-geral/secretaria/processos"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/processos"))}>Processos</SidebarWithCollapsibleSections.NavItem>}{verAr && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherInbox />} selected={pathname === "/admin-geral/secretaria/ar"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/ar"))}>AR — Acompanhamento</SidebarWithCollapsibleSections.NavItem>}</SidebarWithCollapsibleSections.NavSection>}<SidebarWithCollapsibleSections.NavSection label={"Configura\xE7\xF5es"} isCollapsed={isDesktopCollapsed}>{configuraCamara && <><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherUsers />} selected={pathname.startsWith("/admin-geral/secretaria/arbitros")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/arbitros"))}>Árbitros</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherTag />} selected={pathname.startsWith("/admin-geral/secretaria/situacoes")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/situacoes"))}>Situações</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherGitBranch />} selected={pathname.startsWith("/admin-geral/secretaria/fluxos")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/fluxos"))}>Fluxos</SidebarWithCollapsibleSections.NavItem></>}<SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCopy />} selected={pathname.startsWith("/admin-geral/secretaria/modelos") && !pathname.startsWith("/admin-geral/secretaria/modelos-andamento") && !pathname.startsWith("/admin-geral/secretaria/modelos-comunicacao") && !pathname.startsWith("/admin-geral/secretaria/modelos-carta") && !pathname.startsWith("/admin-geral/secretaria/modelos-notificacao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos"))}>Modelos de documento</SidebarWithCollapsibleSections.NavItem>{configuraCamara && <><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherMessageCircle />} selected={pathname.startsWith("/admin-geral/secretaria/modelos-comunicacao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos-comunicacao"))}>Modelos de comunicação</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBell />} selected={pathname.startsWith("/admin-geral/secretaria/modelos-notificacao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos-notificacao"))}>Modelos de alerta</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherFileText />} selected={pathname.startsWith("/admin-geral/secretaria/modelos-carta")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos-carta"))}>Modelos de carta</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherFileText />} selected={pathname.startsWith("/admin-geral/secretaria/modelos-andamento")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos-andamento"))}>Modelos de andamento</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCalendar />} selected={pathname.startsWith("/admin-geral/secretaria/feriados")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/feriados"))}>Feriados</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherClock />} selected={pathname.startsWith("/admin-geral/secretaria/tipos-prazo")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/tipos-prazo"))}>Tipos de prazo</SidebarWithCollapsibleSections.NavItem></>}</SidebarWithCollapsibleSections.NavSection></>;
    $[64] = canSee;
    $[65] = configuraCamara;
    $[66] = handleNavigate;
    $[67] = isCollapsed;
    $[68] = isDesktopCollapsed;
    $[69] = pathname;
    $[70] = secaoSecretariaTemItem;
    $[71] = verAr;
    $[72] = verGestaoPermissoes;
    $[73] = verPainelGeral;
    $[74] = verPrazos;
    $[75] = verProcessos;
    $[76] = verTriagem;
    $[77] = t26;
  } else {
    t26 = $[77];
  }
  let t27;
  if ($[78] !== canSee || $[79] !== handleNavigate || $[80] !== isCollapsed || $[81] !== isDesktopCollapsed || $[82] !== pathname) {
    t27 = canSee("atendimento") && <SidebarWithCollapsibleSections.NavSection label="Atendimento" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherMessageCircle />} selected={pathname.startsWith("/admin-geral/chat-atendimento")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/chat-atendimento"))}>Chat Atendimento</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBarChart2 />} selected={pathname === "/admin-geral/dashboard-atendimento"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/dashboard-atendimento"))}>Dashboard de atendimento</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[78] = canSee;
    $[79] = handleNavigate;
    $[80] = isCollapsed;
    $[81] = isDesktopCollapsed;
    $[82] = pathname;
    $[83] = t27;
  } else {
    t27 = $[83];
  }
  let t28;
  if ($[84] !== canSee || $[85] !== handleNavigate || $[86] !== isCollapsed || $[87] !== isDesktopCollapsed || $[88] !== pathname) {
    t28 = canSee("financeiro") && <SidebarWithCollapsibleSections.NavSection label="Financeiro" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherDollarSign />} selected={pathname === "/admin-geral/financeiro"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/financeiro"))}>Financeiro</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherPackage />} selected={pathname === "/admin-geral/administrativo/catalogo-produtos"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/administrativo/catalogo-produtos"))}>Catálogo de Produtos</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherClock />} selected={pathname.startsWith("/admin-geral/financeiro/trials")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/financeiro/trials"))}>Trials</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherActivity />} selected={pathname.startsWith("/admin-geral/financeiro/apuracao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/financeiro/apuracao"))}>Apuração de Consumo</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherDollarSign />} selected={pathname.startsWith("/admin-geral/financeiro/faturas")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/financeiro/faturas"))}>Faturas</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[84] = canSee;
    $[85] = handleNavigate;
    $[86] = isCollapsed;
    $[87] = isDesktopCollapsed;
    $[88] = pathname;
    $[89] = t28;
  } else {
    t28 = $[89];
  }
  let t29;
  if ($[90] !== canSee || $[91] !== handleNavigate || $[92] !== isCollapsed || $[93] !== isDesktopCollapsed || $[94] !== pathname) {
    t29 = canSee("flows") && <SidebarWithCollapsibleSections.NavSection label="Flows" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherGitBranch />} selected={pathname === "/admin-geral/flows" || pathname.startsWith("/admin-geral/flows/agents") || pathname.startsWith("/admin-geral/flows/shared") || pathname.startsWith("/admin-geral/flows/simulacao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/flows"))}>Agentes de Negociação</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCheckSquare />} selected={pathname.startsWith("/admin-geral/flows/qa")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/flows/qa"))}>Flows Sandbox</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBook />} selected={pathname === "/admin-geral/flows/documentacao"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/flows/documentacao"))}>Documentação</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[90] = canSee;
    $[91] = handleNavigate;
    $[92] = isCollapsed;
    $[93] = isDesktopCollapsed;
    $[94] = pathname;
    $[95] = t29;
  } else {
    t29 = $[95];
  }
  let t30;
  if ($[96] !== canSee || $[97] !== handleNavigate || $[98] !== isCollapsed || $[99] !== isDesktopCollapsed || $[100] !== pathname) {
    t30 = canSee("plataforma") && <SidebarWithCollapsibleSections.NavSection label="Plataforma" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<IntegracaoStatusNavIcon showDot={isDesktopCollapsed} />} rightSlot={!isDesktopCollapsed ? <IntegracaoAlertasBadge /> : null} selected={pathname === "/admin-geral/plataforma/status"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/plataforma/status"))}>Status</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherTrendingUp />} selected={pathname === "/admin-geral/plataforma/logs"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/plataforma/logs"))}>Observabilidade</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherActivity />} selected={pathname === "/admin-geral/plataforma/porteiro"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/plataforma/porteiro"))}>Porteiro de canais</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[96] = canSee;
    $[97] = handleNavigate;
    $[98] = isCollapsed;
    $[99] = isDesktopCollapsed;
    $[100] = pathname;
    $[101] = t30;
  } else {
    t30 = $[101];
  }
  let t31;
  if ($[102] !== isDesktopCollapsed || $[103] !== t15 || $[104] !== t16 || $[105] !== t22 || $[106] !== t23 || $[107] !== t24 || $[108] !== t25 || $[109] !== t26 || $[110] !== t27 || $[111] !== t28 || $[112] !== t29 || $[113] !== t30) {
    t31 = <SidebarWithCollapsibleSections className={t15} isCollapsed={isDesktopCollapsed} header={t16} footer={t22}>{t23}{t24}{t25}{t26}{t27}{t28}{t29}{t30}</SidebarWithCollapsibleSections>;
    $[102] = isDesktopCollapsed;
    $[103] = t15;
    $[104] = t16;
    $[105] = t22;
    $[106] = t23;
    $[107] = t24;
    $[108] = t25;
    $[109] = t26;
    $[110] = t27;
    $[111] = t28;
    $[112] = t29;
    $[113] = t30;
    $[114] = t31;
  } else {
    t31 = $[114];
  }
  return t31;
};
function _temp(state) {
  return state.auth.user?.tipoUsuario;
}